document.querySelectorAll('[data-slider]').forEach(slider=>{const track=slider.querySelector('.hero-track'),dots=[...slider.querySelectorAll('[data-slide]')];let i=0;const show=n=>{i=(n+dots.length)%dots.length;track.style.transform='translateX(-'+(i*50)+'%)';dots.forEach((d,x)=>d.classList.toggle('active',x===i))};dots.forEach((d,n)=>d.addEventListener('click',()=>show(n)));setInterval(()=>show(i+1),2500)});document.querySelectorAll('[data-gallery]').forEach(gallery=>{const track=gallery.querySelector('.gallery-track'),slides=[...track.querySelectorAll('img')],count=gallery.querySelector('.gallery-count span');let i=0,start=null;const show=n=>{i=(n+slides.length)%slides.length;track.style.transform='translateX(-'+(i*100)+'%)';count.textContent=String(i+1).padStart(2,'0')};gallery.querySelector('.gallery-prev').addEventListener('click',()=>show(i-1));gallery.querySelector('.gallery-next').addEventListener('click',()=>show(i+1));gallery.addEventListener('pointerdown',e=>{start=e.clientX;gallery.setPointerCapture(e.pointerId)});gallery.addEventListener('pointerup',e=>{if(start===null)return;const d=e.clientX-start;if(Math.abs(d)>35)show(i+(d<0?1:-1));start=null});gallery.addEventListener('keydown',e=>{if(e.key==='ArrowLeft')show(i-1);if(e.key==='ArrowRight')show(i+1)});setInterval(()=>show(i+1),2000)});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const mainImage = gallery.querySelector('#ProductMainImage');
  const dialog = document.querySelector('[data-gallery-dialog]');
  const dialogImage = dialog?.querySelector('[data-gallery-modal-image]');
  const showImage = (button) => {
    if (!mainImage || !button?.dataset.imageUrl) return;
    mainImage.src = button.dataset.imageUrl;
    mainImage.alt = button.dataset.imageAlt || mainImage.alt;
    gallery.querySelectorAll('[data-gallery-thumbnail]').forEach((item) => item.classList.toggle('is-active', item === button));
  };
  gallery.querySelectorAll('[data-gallery-thumbnail]').forEach((button) => button.addEventListener('click', () => showImage(button)));
  gallery.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => {
    if (!dialog || !dialogImage || !mainImage) return;
    dialogImage.src = mainImage.currentSrc || mainImage.src;
    dialogImage.alt = mainImage.alt;
    dialog.showModal();
  });
  dialog?.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
});
(() => {
  const popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;
  const storageKey = 'khulayzan-newsletter-popup-seen';
  const open = () => { popup.hidden = false; popup.setAttribute('aria-hidden', 'false'); document.body.classList.add('popup-open'); popup.querySelector('input[type="text"]')?.focus(); };
  const close = () => { popup.hidden = true; popup.setAttribute('aria-hidden', 'true'); document.body.classList.remove('popup-open'); sessionStorage.setItem(storageKey, 'true'); };
  popup.querySelectorAll('[data-newsletter-close]').forEach((button) => button.addEventListener('click', close));
  if (popup.querySelector('[data-newsletter-success]')) { open(); return; }
  if (!sessionStorage.getItem(storageKey)) window.setTimeout(open, 850);
})();
(() => {
  const track = document.querySelector('.carousel-track'); const dots = Array.from(document.querySelectorAll('.dot')); if (!track || !dots.length) return; let active = 0; const show = (index) => { active = index; track.style.transform = `translateX(-${active * 50}%)`; dots.forEach((dot, i) => dot.classList.toggle('active', i === active)); }; dots.forEach((dot, index) => dot.addEventListener('click', () => show(index))); setInterval(() => show((active + 1) % dots.length), 2500);
})();
document.querySelectorAll('[data-product-gallery]').forEach((gallery) => { const mainImage = gallery.querySelector('#ProductMainImage'); const dialog = document.querySelector('[data-gallery-dialog]'); const dialogImage = dialog?.querySelector('[data-gallery-modal-image]'); const showImage = (button) => { if (!mainImage || !button?.dataset.imageUrl) return; mainImage.src = button.dataset.imageUrl; mainImage.alt = button.dataset.imageAlt || mainImage.alt; gallery.querySelectorAll('[data-gallery-thumbnail]').forEach((item) => item.classList.toggle('is-active', item === button)); }; gallery.querySelectorAll('[data-gallery-thumbnail]').forEach((button) => button.addEventListener('click', () => showImage(button))); gallery.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => { if (!dialog || !dialogImage || !mainImage) return; dialogImage.src = mainImage.currentSrc || mainImage.src; dialogImage.alt = mainImage.alt; dialog.showModal(); }); dialog?.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog.close()); dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); }); });
/* Variant-aware purchasing controls for the product page. */
(() => {
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const data = document.querySelector('[data-product-variants]');
    if (!data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    const scope = form.closest('.product-page__details') || form;
    const variantSelect = form.querySelector('[data-variant-select]');
    const optionGroups = Array.from(form.querySelectorAll('[data-option-position]'));
    const price = scope.querySelector('[data-product-price-current]');
    const comparePrice = scope.querySelector('[data-product-price-compare]');
    const status = form.querySelector('[data-product-status]');
    const addButton = form.querySelector('[data-add-to-bag]');
    const addLabel = form.querySelector('[data-add-label]');
    const buyButton = form.querySelector('[data-buy-now]');
    const dynamicCheckout = form.querySelector('[data-dynamic-checkout]');
    const quantity = form.querySelector('[data-quantity-input]');
    const formLabels = { soldOut: form.dataset.soldOutLabel || 'Sold out', add: form.dataset.addLabelText || 'Add to cart', unavailable: form.dataset.unavailableLabel || 'Unavailable combination' };
    const directCheckoutQuantity = () => {
      const minimum = Number(quantity?.min) || 1;
      const value = Number(quantity?.value) || minimum;
      return Math.max(minimum, value);
    };
    const syncDirectCheckout = (variant) => {
      if (!buyButton) return;
      const available = Boolean(variant?.available);
      if (available) buyButton.setAttribute('href', `/cart/${variant.id}:${directCheckoutQuantity()}`);
      else buyButton.removeAttribute('href');
      buyButton.setAttribute('aria-disabled', available ? 'false' : 'true');
      buyButton.classList.toggle('is-disabled', !available);
      if ('disabled' in buyButton) buyButton.disabled = !available;
    };

    const selectedOptions = () => optionGroups.map((group) => group.querySelector('[data-option-value]:checked')?.value);
    const matchingVariant = (options) => variants.find((variant) => variant.options.every((value, index) => value === options[index]));

    const updateOptionAvailability = () => {
      const selected = selectedOptions();
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-value]').forEach((input) => {
          const candidate = selected.slice();
          candidate[groupIndex] = input.value;
          const available = variants.some((variant) => variant.available && variant.options.every((value, index) => value === candidate[index]));
          input.disabled = !available;
          input.nextElementSibling?.classList.toggle('is-unavailable', !available);
        });
      });
    };

    const update = (variant, updateUrl = true) => {
      if (!variant) {
        if (status) status.textContent = formLabels.unavailable;
        [addButton, buyButton].forEach((button) => { if (button) button.disabled = true; });
        if (dynamicCheckout) dynamicCheckout.hidden = true;
        syncDirectCheckout(null);
        updateOptionAvailability();
        return;
      }
      if (variantSelect) variantSelect.value = String(variant.id);
      if (price) price.textContent = variant.price_formatted;
      if (comparePrice) {
        comparePrice.textContent = variant.compare_at_price_formatted || '';
        comparePrice.hidden = !(variant.compare_at_price > variant.price);
      }
      const available = variant.available;
      if (status) status.textContent = available ? '' : formLabels.soldOut;
      [addButton, buyButton].forEach((button) => { if (button) button.disabled = !available; });
      if (addLabel) addLabel.textContent = available ? formLabels.add : formLabels.soldOut;
      if (dynamicCheckout) dynamicCheckout.hidden = !available;
      if (quantity) {
        quantity.min = String(variant.quantity_min || 1);
        quantity.step = String(variant.quantity_increment || 1);
        if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
      }
      syncDirectCheckout(variant);
      updateOptionAvailability();
      if (updateUrl && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    optionGroups.forEach((group) => group.addEventListener('change', () => {
      group.querySelector('[data-option-value]:checked') && (group.querySelector('[data-selected-option]').textContent = group.querySelector('[data-option-value]:checked').value);
      update(matchingVariant(selectedOptions()));
    }));
    variantSelect?.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === variantSelect.value);
      if (!variant) return;
      optionGroups.forEach((group, index) => {
        const input = Array.from(group.querySelectorAll('[data-option-value]')).find((item) => item.value === variant.options[index]);
        if (input) { input.checked = true; group.querySelector('[data-selected-option]').textContent = input.value; }
      });
      update(variant);
    });
    form.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => {
      if (!quantity) return;
      const step = Number(quantity.step) || 1;
      const minimum = Number(quantity.min) || 1;
      quantity.value = Math.max(minimum, (Number(quantity.value) || minimum) + (Number(button.dataset.quantityChange) * step));
      const activeVariant = variants.find((item) => String(item.id) === variantSelect?.value);
      syncDirectCheckout(activeVariant);
    }));
    /* data-buy-now direct checkout guard */
    buyButton?.addEventListener('click', (event) => {
      const activeVariant = variants.find((item) => String(item.id) === variantSelect?.value);
      syncDirectCheckout(activeVariant);
      if (buyButton.tagName === 'BUTTON') {
        event.preventDefault();
        if (activeVariant?.available) window.location.href = `/cart/${activeVariant.id}:${directCheckoutQuantity()}`;
        return;
      }
      if (buyButton.getAttribute('aria-disabled') === 'true' || !buyButton.getAttribute('href')) event.preventDefault();
    });
    update(variants.find((variant) => String(variant.id) === variantSelect?.value) || variants[0], false);
  });
})();



/* Shopify Ajax Bag: adds the selected variant to the real cart and updates the header count. */
(() => {
  const drawer = document.querySelector('[data-bag-drawer]');
  if (!drawer) return;
  const items = drawer.querySelector('[data-bag-items]');
  const empty = drawer.querySelector('[data-bag-empty]');
  const summary = drawer.querySelector('[data-bag-summary]');
  const total = drawer.querySelector('[data-bag-total]');
  const message = drawer.querySelector('[data-bag-message]');
  const productCache = new Map();
  let currentCart;
  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
  const formatMoney = (amount, currency) => { try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'PKR' }).format((amount || 0) / 100); } catch (_) { return `${(amount || 0) / 100} ${currency || ''}`; } };
  const open = () => { if (!drawer.open) drawer.showModal(); };
  const setBusy = (busy) => {
    items.setAttribute('aria-busy', busy ? 'true' : 'false');
    drawer.classList.toggle('is-updating', busy);
    items.querySelectorAll('[data-bag-control]').forEach((control) => { control.disabled = busy; });
  };
  const requestJson = async (url, options, fallbackMessage) => {
    const response = await fetch(url, options);
    if (!response.ok) {
      const result = await response.json().catch(() => ({}));
      throw new Error(result.description || result.message || fallbackMessage || drawer.dataset.genericError);
    }
    return response.json();
  };
  const getProduct = (handle) => {
    if (!productCache.has(handle)) {
      productCache.set(handle, requestJson(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } }, drawer.dataset.genericError));
    }
    return productCache.get(handle);
  };

  const hydrateSizeSelectors = async (cart) => {
    await Promise.all(cart.items.map(async (item, index) => {
      if (!item.handle || item.product_has_only_default_variant) return;
      const control = items.querySelector(`[data-bag-item="${index}"] [data-bag-variant-control]`);
      if (!control) return;
      try {
        const product = await getProduct(item.handle);
        const optionDefinitions = (product.options || []).map((option, optionIndex) => (
          typeof option === 'string' ? { name: option, position: optionIndex + 1 } : option
        ));
        let sizeIndex = optionDefinitions.findIndex((option) => /size/i.test(option.name || ''));
        if (sizeIndex < 0 && optionDefinitions.length === 1) sizeIndex = 0;
        if (sizeIndex < 0) return;

        const currentVariant = (product.variants || []).find((variant) => String(variant.id) === String(item.variant_id));
        const currentOptions = item.variant_options?.length ? item.variant_options : (currentVariant?.options || []);
        const choices = new Map();
        (product.variants || []).forEach((variant) => {
          if (!variant.available) return;
          const matchesOtherOptions = (variant.options || []).every((value, optionIndex) => (
            optionIndex === sizeIndex || value === currentOptions[optionIndex]
          ));
          if (matchesOtherOptions) choices.set(variant.options[sizeIndex], variant);
        });
        if (!choices.size) return;

        const label = document.createElement('label');
        label.className = 'bag-drawer__size';
        const labelText = document.createElement('span');
        labelText.textContent = optionDefinitions[sizeIndex]?.name || drawer.dataset.sizeLabel || 'Size';
        const select = document.createElement('select');
        select.dataset.bagControl = '';
        select.dataset.bagSize = '';
        select.setAttribute('aria-label', labelText.textContent);
        choices.forEach((variant, optionValue) => {
          const option = document.createElement('option');
          option.value = variant.id;
          option.textContent = optionValue;
          option.selected = String(variant.id) === String(item.variant_id);
          select.appendChild(option);
        });
        label.append(labelText, select);
        control.replaceChildren(label);
      } catch (_) {
        /* Keep the current variant title when product option data cannot load. */
      }
    }));
  };

  const render = (cart) => {
    currentCart = cart;
    document.querySelectorAll('[data-bag-count]').forEach((count) => { count.textContent = cart.item_count; });
    empty.hidden = cart.item_count > 0;
    summary.hidden = cart.item_count === 0;
    if (total) total.textContent = formatMoney(cart.total_price, cart.currency);
    items.innerHTML = cart.items.map((item, index) => {
      const rule = item.quantity_rule || {};
      const minimum = Number(rule.min) || 1;
      const increment = Number(rule.increment) || 1;
      const maximum = Number(rule.max) || 0;
      const maximumAttribute = maximum ? ` max="${maximum}"` : '';
      const imageUrl = item.featured_image?.url || item.image;
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return `<article class="bag-drawer__item" data-bag-item="${index}" data-line-key="${escapeHtml(item.key)}">
        <a class="bag-drawer__item-image" href="${escapeHtml(item.url)}">${imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '<span class="bag-drawer__item-placeholder"></span>'}</a>
        <div class="bag-drawer__item-content">
          <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>
          <div class="bag-drawer__variant-control" data-bag-variant-control>${variantTitle ? `<p>${escapeHtml(variantTitle)}</p>` : ''}</div>
          <div class="bag-drawer__quantity">
            <span>${escapeHtml(drawer.dataset.quantityLabel || 'Qty')}</span>
            <div class="bag-drawer__quantity-control">
              <button type="button" data-bag-control data-bag-quantity-change="-${increment}" aria-label="${escapeHtml(drawer.dataset.decreaseLabel || 'Decrease quantity')}">&minus;</button>
              <input type="number" data-bag-control data-bag-quantity-input value="${item.quantity}" min="${minimum}"${maximumAttribute} step="${increment}" inputmode="numeric" aria-label="${escapeHtml(drawer.dataset.quantityLabel || 'Quantity')}">
              <button type="button" data-bag-control data-bag-quantity-change="${increment}" aria-label="${escapeHtml(drawer.dataset.increaseLabel || 'Increase quantity')}">&plus;</button>
            </div>
          </div>
          <div class="bag-drawer__item-footer">
            <strong>${formatMoney(item.final_line_price, cart.currency)}</strong>
            <button type="button" class="bag-drawer__remove" data-bag-control data-bag-remove>${escapeHtml(drawer.dataset.removeLabel || 'Remove')}</button>
          </div>
        </div>
      </article>`;
    }).join('');
    hydrateSizeSelectors(cart);
  };
  const getCart = async () => {
    const cart = await requestJson(drawer.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } }, drawer.dataset.loadError || 'Could not load your bag.');
    render(cart);
    return cart;
  };
  const updateLine = (key, quantity) => requestJson(drawer.dataset.cartChangeUrl, {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  }, drawer.dataset.genericError);
  const runUpdate = async (operation, successMessage) => {
    setBusy(true);
    message.textContent = drawer.dataset.updatingMessage || 'Updating your bag...';
    try {
      const cart = await operation();
      render(cart);
      message.textContent = successMessage;
    } catch (error) {
      message.textContent = error.message || drawer.dataset.genericError || 'Your bag could not be updated.';
      await getCart().catch(() => {});
    } finally {
      setBusy(false);
    }
  };

  document.querySelectorAll('[data-bag-open]').forEach((link) => link.addEventListener('click', async (event) => { event.preventDefault(); try { await getCart(); message.textContent = ''; open(); } catch (error) { window.location.href = link.href; } }));
  drawer.querySelector('[data-bag-close]')?.addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', (event) => { if (event.target === drawer) drawer.close(); });
  items.addEventListener('click', (event) => {
    const itemElement = event.target.closest('[data-bag-item]');
    if (!itemElement) return;
    const key = itemElement.dataset.lineKey;
    const removeButton = event.target.closest('[data-bag-remove]');
    if (removeButton) {
      runUpdate(() => updateLine(key, 0), drawer.dataset.removedMessage || 'Item removed.');
      return;
    }
    const quantityButton = event.target.closest('[data-bag-quantity-change]');
    if (!quantityButton) return;
    const input = itemElement.querySelector('[data-bag-quantity-input]');
    const minimum = Number(input.min) || 1;
    const maximum = Number(input.max) || Infinity;
    const nextQuantity = Math.min(maximum, Math.max(minimum, Number(input.value) + Number(quantityButton.dataset.bagQuantityChange)));
    if (nextQuantity === Number(input.value)) return;
    runUpdate(() => updateLine(key, nextQuantity), drawer.dataset.quantityUpdatedMessage || 'Quantity updated.');
  });
  items.addEventListener('change', (event) => {
    const itemElement = event.target.closest('[data-bag-item]');
    if (!itemElement) return;
    const key = itemElement.dataset.lineKey;
    if (event.target.matches('[data-bag-quantity-input]')) {
      const minimum = Number(event.target.min) || 1;
      const maximum = Number(event.target.max) || Infinity;
      const increment = Number(event.target.step) || 1;
      const requested = Number(event.target.value) || minimum;
      const normalized = Math.min(maximum, Math.max(minimum, minimum + Math.round((requested - minimum) / increment) * increment));
      runUpdate(() => updateLine(key, normalized), drawer.dataset.quantityUpdatedMessage || 'Quantity updated.');
      return;
    }
    if (!event.target.matches('[data-bag-size]')) return;
    const item = currentCart?.items.find((cartItem) => cartItem.key === key);
    const nextVariantId = Number(event.target.value);
    if (!item || nextVariantId === Number(item.variant_id)) return;
    runUpdate(async () => {
      const addItem = { id: nextVariantId, quantity: item.quantity };
      if (item.properties && Object.keys(item.properties).length) addItem.properties = item.properties;
      const sellingPlanId = item.selling_plan_allocation?.selling_plan?.id;
      if (sellingPlanId) addItem.selling_plan = sellingPlanId;
      await requestJson(drawer.dataset.cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [addItem] })
      }, drawer.dataset.genericError);
      return updateLine(item.key, 0);
    }, drawer.dataset.sizeUpdatedMessage || 'Size updated.');
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    const submitter = event.submitter;
    if (!form || !submitter?.matches('[data-add-to-bag]')) return;
    event.preventDefault();

    submitter.disabled = true;
    try {
      const response = await fetch(drawer.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) { const result = await response.json().catch(() => ({})); throw new Error(result.description || drawer.dataset.addError || 'This item could not be added to your bag.'); }
      const addedItem = await response.json();
      document.dispatchEvent(new CustomEvent('khulayzan:add_to_cart', { detail: addedItem }));
      await getCart();
      message.textContent = drawer.dataset.addedMessage || 'Added to your bag.';
      open();
    } catch (error) {
      message.textContent = error.message || drawer.dataset.genericError || 'This item could not be added. Please try again.';
      open();
    } finally { submitter.disabled = false; }
  });
})();

/* Product purchase layout fallback for cached Shopify product pages. */
(() => {
  const run = () => {
    document.querySelectorAll('.product-page').forEach((page) => {
      const details = page.querySelector('.product-page__details');
      if (!details) return;
      page.classList.add('product-page--purchase-first');

      const form = details.querySelector('[data-product-form], .product-form');
      const description = details.querySelector('.product-page__description');
      if (form) form.classList.add('product-form--priority');

      if (form && description && !description.closest('.product-description-accordion')) {
        details.insertBefore(form, description);
        const accordion = document.createElement('details');
        accordion.className = 'product-description-accordion';
        const summary = document.createElement('summary');
        summary.textContent = 'Product details';
        description.parentNode.insertBefore(accordion, description);
        accordion.appendChild(summary);
        accordion.appendChild(description);
      }

      page.querySelectorAll('.payment-options,.product-form__direct-buy').forEach((item) => { item.hidden = true; item.style.display = 'none'; });
      if (!form) return;

      const addButton = form.querySelector('[data-add-to-bag]');
      const variantSelect = form.querySelector('[name="id"]');
      const quantityInput = form.querySelector('[name="quantity"]');
      let actions = addButton?.closest('.product-form__checkout-actions') || form.querySelector('.product-form__checkout-actions');
      if (!actions && addButton) {
        actions = document.createElement('div');
        actions.className = 'product-form__checkout-actions';
        addButton.parentNode.insertBefore(actions, addButton);
        actions.appendChild(addButton);
      }
      if (!actions) return;

      let buyLink = form.querySelector('[data-buy-now]');
      if (!buyLink || buyLink.tagName !== 'A') {
        const replacement = document.createElement('a');
        replacement.className = buyLink?.className || 'product-form__checkout-now';
        replacement.dataset.buyNow = '';
        replacement.dataset.directCheckout = '';
        replacement.setAttribute('role', 'button');
        replacement.textContent = 'Buy it now';
        if (buyLink) buyLink.replaceWith(replacement); else actions.appendChild(replacement);
        buyLink = replacement;
      }
      buyLink.classList.add('product-form__checkout-now');

      const selectedQty = () => {
        const minimum = Number(quantityInput?.min) || 1;
        const value = Number(quantityInput?.value) || minimum;
        return Math.max(minimum, value);
      };
      const sync = () => {

        const variantId = variantSelect?.value;
        if (!variantId || addButton?.disabled) {
          buyLink.removeAttribute('href');
          buyLink.setAttribute('aria-disabled', 'true');
          buyLink.classList.add('is-disabled');
          return;
        }
        buyLink.href = `/cart/${variantId}:${selectedQty()}`;
        buyLink.setAttribute('aria-disabled', 'false');
        buyLink.classList.remove('is-disabled');
      };

      form.addEventListener('change', () => setTimeout(sync, 0));
      form.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => setTimeout(sync, 0)));
      buyLink.addEventListener('click', (event) => { sync(); if (buyLink.getAttribute('aria-disabled') === 'true' || !buyLink.getAttribute('href')) event.preventDefault(); });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
/* Editable Signature article galleries: arrows, swipe, keyboard, and optional autoplay. */
(() => {
  document.querySelectorAll('[data-signature-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('.signature-gallery-track');
    const slides = Array.from(track?.querySelectorAll('img') || []);
    const current = gallery.querySelector('[data-gallery-current]');
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    if (!track || !slides.length) return;
    let index = 0;
    let startX = null;
    let startedOnControl = false;
    let swiped = false;
    let timer;
    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      if (current) current.textContent = String(index + 1).padStart(2, '0');
    };
    previous?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));
    gallery.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      startedOnControl = Boolean(event.target.closest('button, a'));
      swiped = false;
      gallery.setPointerCapture?.(event.pointerId);
    });
    gallery.addEventListener('pointerup', (event) => {
      if (startX === null) return;
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 24) {
        swiped = true;
        show(index + (distance < 0 ? 1 : -1));
      } else if (!startedOnControl && gallery.dataset.productUrl) {
        window.location.assign(gallery.dataset.productUrl);
      }
      startX = null;
      startedOnControl = false;
    });
    gallery.addEventListener('pointercancel', () => { startX = null; startedOnControl = false; });
    gallery.addEventListener('click', (event) => {
      if (event.target.closest('button, a')) return;
      if (swiped) {
        event.preventDefault();
        swiped = false;
        return;
      }
      if (gallery.dataset.productUrl) window.location.assign(gallery.dataset.productUrl);
    });
    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
      if (event.key === 'Enter' && gallery.dataset.productUrl) window.location.assign(gallery.dataset.productUrl);
    });
    const speed = Number(gallery.dataset.autoplayMs) || 0;
    const start = () => {
      if (speed < 1000 || slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      window.clearInterval(timer);
      timer = window.setInterval(() => show(index + 1), speed);
    };
    gallery.addEventListener('mouseenter', () => window.clearInterval(timer));
    gallery.addEventListener('mouseleave', start);
    gallery.addEventListener('focusin', () => window.clearInterval(timer));
    gallery.addEventListener('focusout', start);
    start();
  });
})();

/* Header product search: Shopify predictive keyword matching with full-search fallback. */
(() => {
  const dialog = document.querySelector('[data-product-search-dialog]');
  if (!dialog) return;

  const openButtons = document.querySelectorAll('[data-product-search-open]');
  const closeButton = dialog.querySelector('[data-product-search-close]');
  const form = dialog.querySelector('[data-product-search-form]');
  const input = dialog.querySelector('[data-product-search-input]');
  const status = dialog.querySelector('[data-product-search-status]');
  const results = dialog.querySelector('[data-product-search-results]');
  let timer;
  let request;

  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
  }[character]));

  const fullSearchUrl = (query) => {
    const url = new URL(form.action, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url.toString();
  };

  const renderProducts = (products, query) => {
    if (!products.length) {
      status.textContent = 'No products matched “' + query + '”.';
      results.innerHTML = '<p class="product-search__empty">Try another product name, collection, color, or style.</p>';
      return;
    }

    status.textContent = products.length + ' product' + (products.length === 1 ? '' : 's') + ' found for “' + query + '”.';
    results.innerHTML = products.map((product) => {
      const imageObject = product.featured_image || product.image;
      const imageUrl = typeof imageObject === 'string' ? imageObject : imageObject?.url;
      const imageAlt = typeof imageObject === 'object' ? (imageObject.alt || product.title) : product.title;
      return '<a class="product-search-result" href="' + escapeHtml(product.url) + '">' +
        (imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy">' : '<span class="product-search-result__placeholder"></span>') +
        '<span class="product-search-result__copy">' +
          (product.vendor ? '<small>' + escapeHtml(product.vendor) + '</small>' : '') +
          '<strong>' + escapeHtml(product.title) + '</strong>' +
          (product.price ? '<span>' + escapeHtml(product.price) + '</span>' : '') +
        '</span></a>';
    }).join('') +
      '<a class="product-search__all" href="' + escapeHtml(fullSearchUrl(query)) + '">View all matching products &rarr;</a>';
  };

  const searchProducts = async (query) => {
    request?.abort();
    request = new AbortController();
    status.textContent = 'Searching products…';
    results.innerHTML = '<div class="product-search__loading" aria-hidden="true"></div>';

    try {
      const url = new URL(dialog.dataset.predictiveUrl, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '8');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor');
      const response = await fetch(url, { headers: { Accept: 'application/json' }, signal: request.signal });
      if (!response.ok) throw new Error('Search request failed');
      const payload = await response.json();
      renderProducts(payload?.resources?.results?.products || [], query);
    } catch (error) {
      if (error.name === 'AbortError') return;
      status.textContent = 'Live results are temporarily unavailable.';
      results.innerHTML = '<a class="product-search__all" href="' + escapeHtml(fullSearchUrl(query)) + '">Search all products for “' + escapeHtml(query) + '” &rarr;</a>';
    }
  };

  openButtons.forEach((button) => button.addEventListener('click', () => {
    if (typeof dialog.showModal !== 'function') {
      window.location.assign(form.action);
      return;
    }
    if (!dialog.open) dialog.showModal();
    window.setTimeout(() => input.focus(), 0);
  }));
  closeButton?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  input?.addEventListener('input', () => {
    window.clearTimeout(timer);
    const query = input.value.trim();
    if (query.length < 2) {
      request?.abort();
      status.textContent = query ? 'Enter at least two characters.' : 'Enter a product name or keyword.';
      results.innerHTML = '';
      return;
    }
    timer = window.setTimeout(() => searchProducts(query), 250);
  });
})();


/* Mobile product gallery: keep the main image, thumbnails, and swipes in sync. */
(() => {
  const initProductGallery = (gallery) => {
    const stage = gallery.querySelector('[data-gallery-zoom]');
    const mainImage = gallery.querySelector('#ProductMainImage');
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    if (!stage || !mainImage || thumbnails.length < 2) return;

    let currentIndex = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));
    let startX = null;
    let startY = null;
    let suppressZoom = false;
    let swipeHandled = false;

    const showImage = (nextIndex, shouldFocusThumbnail = false) => {
      currentIndex = (nextIndex + thumbnails.length) % thumbnails.length;
      const thumbnail = thumbnails[currentIndex];
      const imageUrl = thumbnail.dataset.imageUrl;
      if (!imageUrl) return;

      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = imageUrl;
      mainImage.alt = thumbnail.dataset.imageAlt || mainImage.alt;

      thumbnails.forEach((item, index) => {
        const active = index === currentIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });

      thumbnail.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      if (shouldFocusThumbnail) thumbnail.focus({ preventScroll: true });
    };

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', (event) => {
        event.preventDefault();
        showImage(index);
      });
    });

    stage.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      startX = event.clientX;
      startY = event.clientY;
      swipeHandled = false;
      stage.setPointerCapture?.(event.pointerId);
    });

    stage.addEventListener('pointermove', (event) => {
      if (swipeHandled || startX === null || startY === null) return;
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      if (Math.abs(deltaX) >= 24 && Math.abs(deltaX) > Math.abs(deltaY)) {
        suppressZoom = true;
        swipeHandled = true;
        showImage(currentIndex + (deltaX < 0 ? 1 : -1));
        startX = null;
        startY = null;
      }
    });

    stage.addEventListener('pointerup', (event) => {
      if (swipeHandled || startX === null || startY === null) return;
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      if (Math.abs(deltaX) >= 24 && Math.abs(deltaX) > Math.abs(deltaY)) {
        suppressZoom = true;
        showImage(currentIndex + (deltaX < 0 ? 1 : -1));
      }
      startX = null;
      startY = null;
    });

    stage.addEventListener('pointercancel', () => {
      startX = null;
      startY = null;
    });

    stage.addEventListener('click', (event) => {
      if (!suppressZoom) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressZoom = false;
    }, true);

    stage.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(currentIndex - 1, true);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(currentIndex + 1, true);
      }
    });

    showImage(currentIndex);
  };

  const run = () => document.querySelectorAll('[data-product-gallery]').forEach(initProductGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
